import { BreakpointObserver } from '@angular/cdk/layout'
import { DatePipe } from '@angular/common'
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core'
import { ChartDataset } from 'chart.js/auto'
import { ESTPipe } from 'src/app/features/shared/pipes/est.pipe'
import {
  PdDetails,
  PremiumDiscountResponse,
} from 'src/app/models/premium-discount-response.model'
import { PremiumDiscountService } from 'src/app/services/premium-discount/premium-discount.service'

@Component({
  selector: 'app-current',
  templateUrl: './current.component.html',
  styleUrls: ['./current.component.scss'],
})
export class CurrentComponent {
  @Input() data: any
  @Input() fundId: string
  @Input() ticker: string
  @Input() modelLabel: string
  @Input() shareSplitDate: string | null = null
  @Input() shareSplitPrice: number | null = null
  @ViewChild('horizontalScrollTable') horizontalScrollTable: ElementRef
  datasets: ChartDataset[] = [
    { data: [], label: 'Price' },
    { data: [], label: 'NAV' },
  ]
  barDatasets: ChartDataset[] = [{ data: [], label: '' }]
  labels: any
  labelText = ''
  isSmallScreen: boolean
  chatLabels: string[] = []
  barChatLabels: string[] = []
  chartIndex: any
  premiumDiscount: PremiumDiscountResponse
  premiumDiscountCurrent: any
  infoNotAvailable = false
  displayToggle = 'chart'
  premiumDiscountData: PdDetails[]
  public pageNumber = 1
  estPipe: ESTPipe

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  scrollBarPosition = 0
  splitIndex = -1
  showRightButton = true
  tableContainer: HTMLElement

  public datePipe: DatePipe

  constructor(
    public readonly premiumDiscountService: PremiumDiscountService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly breakpointObserver: BreakpointObserver,
  ) {
    this.estPipe = new ESTPipe()
  }

  ngOnInit() {
    this.breakpointObserver
      .observe(['(max-width: 576px)'])
      .subscribe((result) => {
        this.isSmallScreen = result.matches
      })

    if (this.isSmallScreen) {
      this.displayToggle = 'table'
    } else {
      this.displayToggle = 'chart'
    }
  }

  ngAfterViewInit() {
    this.calltableScrollEvent()
  }

  public greaterThan(index: number) {
    return index > 0 || index === 0
  }

  ngOnChanges(): void {
    this.premiumDiscountCurrentChanges()
  }

  onChange(event: string) {
    this.displayToggle = event
  }

  premiumDiscountCurrentChanges() {
    if (this.data && this.fundId) {
      this.premiumDiscountService
        .getPremiumDiscount(this.fundId, this.data.element.prdQualifier)
        .subscribe((params) => {
          this.premiumDiscount = params
          if (params.pdDetails.length <= 0) {
            this.infoNotAvailable = true
          }
          this.premiumDiscount.pdDetails.forEach((details) => {
            this.datasets[0].data.push(Number(details.marketPrice))
            this.datasets[1].data.push(Number(details.nav))
            this.chatLabels.push(details.effectiveDate.split('T')[0])
          })
          this.premiumDiscountCurrent =
            this.premiumDiscount.pdDetails[
              this.premiumDiscount.pdDetails.length - 1
            ]

          this.premiumDiscount.pdDetails.forEach((details) => {
            this.barDatasets[0].data.push(
              Number(details.premiumDiscountPercentage),
            )
            this.barChatLabels.push(
              this.estPipe.transform(details.effectiveDate),
            )
          })
          this.premiumDiscountData = this.premiumDiscount.pdDetails
        })
    }
  }
  onDataUpdated($event: {
    labels: string[]
    datasets: any[]
    barDatasets: any[]
    splitIndex: number
  }) {
    this.splitIndex = $event.splitIndex
  }
  chartMouseOut() {
    this.chartIndex = this.premiumDiscount.pdDetails.length - 1
  }
  activeItemChanged($event) {
    const rawIndex = $event.index
    if (rawIndex === this.splitIndex) return
    this.chartIndex =
      this.splitIndex >= 0 && rawIndex > this.splitIndex
        ? rawIndex - 1
        : rawIndex
  }
  ngAfterViewChecked() {
    this.cdRef.detectChanges()
  }
  setPageNumber(changedNumber: number) {
    this.pageNumber = changedNumber
    const max = 10
    if (this.premiumDiscount.pdDetails.length > max) {
      this.premiumDiscountData = this.premiumDiscount.pdDetails.slice(
        (this.pageNumber - 1) * max,
        this.pageNumber * max,
      )
    }
  }

  calltableScrollEvent() {
    setTimeout(() => {
      if (this.horizontalScrollTable) {
        this.horizontalScrollTable.nativeElement.addEventListener(
          'scroll',
          this.scrollTableHandler.bind(this),
        )
      }
    }, 300)
  }

  scrollTableHandler() {
    this.showRightButton =
      this.horizontalScrollTable.nativeElement.offsetWidth +
        this.horizontalScrollTable.nativeElement.scrollLeft <
      this.horizontalScrollTable.nativeElement.scrollWidth - 1
    this.scrollBarPosition = this.horizontalScrollTable.nativeElement.scrollLeft
  }

  moveRight() {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    this.horizontalScrollTable.nativeElement.scrollLeft += 150
    this.scrollTableHandler()
  }

  moveLeft() {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    this.horizontalScrollTable.nativeElement.scrollLeft -= 150
    this.scrollTableHandler()
  }
}
